import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Component/Home';
import ContactForm from './Component/contact/ContactForm';
import CustomNavbar from './Component/Navbar/Navbar'; // ✅ Renamed import
import Footer from './Component/Footer/Footer';
import About from './Component/About/About';
import Gallery from './Component/Gallery/Gallery';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import CareerPage from './Component/Career/career';


const App = () => {
  return (
    <Router>
      <CustomNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/career" element={<CareerPage />}/>
        {/* Optional: fallback route */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
